// @flow

import { rem } from 'polished';
import { useSelector } from 'react-redux';
import styled, { type StyledComponent } from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { SpinePlayer } from '../../../modules/shared/components/SpinePlayer';
import type { RootState } from '../../../store/types';
import { colors, fontFamily } from '../../../styles/GlobalStyle';

type GlobalLoadingRawProps = {
  className: string,
};

const GlobalLoadingRaw = ({ className }: GlobalLoadingRawProps) => {
  const common = useSelector((state: RootState) => state.common);
  const websocket = useSelector((state: RootState) => state.websocket);

  const { body }: any = document;
  if (!common.globalLoading || websocket.layerError) {
    body.classList.remove('noscroll');
    return null;
  }
  body.classList.add('noscroll');

  return (
    <div className={className}>
      {common.globalLoading && (
        <div className={'layerError-cont'}>
          <div className={'layerError-illustration'}>
            <SpinePlayer
              skeletonName={common.globalLoading.spine}
              current={common.globalLoading.animationNumber || 0}
              fallback={(
                <img
                  src={common.globalLoading.fallback}
                  alt={''}
                />
              )}
              autoPlay
            />
          </div>
          <div className={'layerError-title'}>{common.globalLoading.title}</div>
          <div className={'layerError-text'}>{common.globalLoading.text}</div>
        </div>
      )}
    </div>
  );
};

export const GlobalLoading: StyledComponent<
  GlobalLoadingRawProps,
  {},
  typeof GlobalLoadingRaw
> = styled(GlobalLoadingRaw)`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  padding: 30px;

  .layerError-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 400px;
    width: 100%;
  }

  .layerError-illustration {
    margin: 30px 0 50px;
    position: relative;
    height: 400px;
    width: 100%;
  }

  .layerError-title {
    font-family: ${fontFamily.secondary.regular.fontFamily};
    color: ${colors.yellow};
    font-size: ${rem(30)};
    margin-bottom: 20px;
    position: relative;
  }

  .layerError-text {
    text-transform: uppercase;
    font-family: ${fontFamily.primary.black.fontFamily};
    font-weight: ${fontFamily.primary.black.fontWeight};
    font-size: ${rem(16)};
    margin-bottom: 65px;
    text-align: center;
    position: relative;
  }
`;
